module.exports = __webpack_public_path__ + "static/media/depositphotos_64087125-stock-photo-raw-cereals.45e9ad4a.jpg";